import path from 'path'

// Double decoding because the backend will encode already encoded stuff...
export const getCharacterizationZipFileName = (zipFileURL: string) =>
  path.basename(decodeURIComponent(decodeURIComponent(zipFileURL)))
